<template>
    <div class="maintenance-wrapper">
        <img class="docer-image" src="../../assets/images/docer.png" />
        <div class="maintenance-content">Docer is under maintenance, come back later...</div>
    </div>
</template>

<script>
    export default {
        data: () => ({}),
    }
</script>

<style scoped>
    .maintenance-wrapper {
        height: 100%;
        position: absolute;
        text-align: center;
        width: 600px;
        height: 100px;
        top: 50%;
        left: 50%;
        margin-left: -300px;
        margin-top: -50px;
    }

    .maintenance-content {
        font-size: 25px;
        color: #ccc;
        font-style: italic;
    }

    .docer-image {
        display: block;
        width: 120px;
        opacity: 0.35;
        filter: grayscale(100%);
        filter: gray;
        margin: 0 auto 18px;
    }
</style>



// WEBPACK FOOTER //
// Maintenance.vue?79d5d5f5